import React, { useContext, useEffect, useState } from "react";
import SecondaryHeading from "../../../utils/SecondaryHeading/SecondaryHeading";
import TestimonialsSlider from "./Sliders/TestimonialsSlider";
import Timer from "../../../main/Timer/Timer";
import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";
import axios from "axios";
import Loading from "../../../utils/Loader/Loading";
import { MyContext } from "../../../pages/Funnel";

const Testimonials = ({ id }) => {
  let [state, setState] = useState([]);
  let [isLoading, setIsLoading] = useState(true);
  let [isError, setIsError] = useState(false);

  useEffect(() => {
    let fetchCards = async () => {
      try {
        let response = await axios.get(
          `https://vercel-deployment-w4ja.onrender.com/api/reviews_get/${id}`
        );
        setState(response.data.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCards();
  }, []);
  const { state: details } = useContext(MyContext);

  return (
    <>
      {isLoading && (
        <div className="my-50 flex justify-center items-center h-screen">
          <Loading />
        </div>
      )}
      {!isLoading && !isError && state.length !== 0 && (
        <section className="max-w-7xl m-auto mt-16 max-sm:px-5 ">
          <div className="mb-10 flex flex-col justify-center items-center gap-2">
            <h6 className="text-primary font-normal text-base">TESTIMONIALS</h6>
            <SecondaryHeading>What Our Student Say About Us</SecondaryHeading>
          </div>
          <div className=" relative">
            <div className=" m-auto  max-w-6xl">
              <TestimonialsSlider data={state} />
            </div>
          </div>
          <div className="text-center mt-6">
            <Timer />
            <PrimaryBtn>Enroll Now</PrimaryBtn>
          </div>
        </section>
      )}
      {isError && "Error Occurred"}
    </>
  );
};

export default Testimonials;
